import React, { FC, useCallback, useMemo } from 'react';

import { PaymentConceptAmountProps } from './types';
import styles from './styles.module.css';

const PRICE_PARTS_DEFAULTS = {
  symbol: '$',
  amount: '--',
  decimals: '--',
};

export const PaymentConceptAmount: FC<PaymentConceptAmountProps> = ({
  name,
  label,
  value,
}) => {
  const parseCurrency = useCallback((value: string): number => {
    if (!value) return 0;

    const cleaned = value.replace(/[^0-9.-]/g, '');
    const parsed = parseFloat(cleaned);

    return isNaN(parsed) ? 0 : parsed;
  }, []);

  const splitPriceParts = useCallback((price: number) => {
    const symbol = '$';
    const formattedValue = price.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const [valueAmount, decimals] = formattedValue.split('.');

    return {
      priceSymbol: symbol ? symbol : PRICE_PARTS_DEFAULTS.symbol,
      priceAmount: price ? valueAmount : PRICE_PARTS_DEFAULTS.amount,
      priceDecimals: price ? decimals : PRICE_PARTS_DEFAULTS.decimals,
    };
  }, []);

  const { priceSymbol, priceAmount, priceDecimals } = useMemo(() => {
    return splitPriceParts(parseCurrency(value));
  }, [value, splitPriceParts, parseCurrency]);

  return (
    <div
      className={styles.paymentConcept}
      data-testid={`payment-concept-${name}`}
    >
      <span className={styles.conceptLabel}>{label}</span>
      <span className={styles.conceptValue}>
        <span>{priceSymbol}</span>
        {priceAmount}
        {'.'}
        {priceDecimals}
      </span>
    </div>
  );
};
